import { render, staticRenderFns } from "./AccountingView.vue?vue&type=template&id=1196b97e"
import script from "./AccountingView.vue?vue&type=script&lang=js"
export * from "./AccountingView.vue?vue&type=script&lang=js"
import style0 from "./AccountingView.vue?vue&type=style&index=0&id=1196b97e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports